/**
 * (Amazon) tag types.
 */
export var AffiliateTagLevel;
(function (AffiliateTagLevel) {
    /** Affiliate tag provided by unified config (site level) */
    AffiliateTagLevel[AffiliateTagLevel["Site"] = 0] = "Site";
    /** Affiliate tag set at post level */
    AffiliateTagLevel[AffiliateTagLevel["Post"] = 1] = "Post";
    /** Override level for syndication tags */
    AffiliateTagLevel[AffiliateTagLevel["Override"] = 2] = "Override";
})(AffiliateTagLevel || (AffiliateTagLevel = {}));
//# sourceMappingURL=tags.js.map